
import { ReactComponent as Logo } from "../assets/icons/logo.svg";
import { ReactComponent as LogoText } from "../assets/icons/logoText.svg";
import { ReactComponent as LogoText2 } from "../assets/icons/logoText2.svg";
import { ReactComponent as Figure } from "../assets/icons/mountain.svg";
import { ReactComponent as Satellite } from "../assets/icons/satellite.svg";
import { ReactComponent as Street } from "../assets/icons/signpost-big.svg";
import { ReactComponent as Marks } from "../assets/icons/spline-pointer.svg";
import { ReactComponent as Area } from "../assets/icons/square-dashed-mouse-pointer.svg";
import { ReactComponent as Datas } from "../assets/icons/datas.svg";
import { ReactComponent as Secur } from "../assets/icons/secur.svg";
import { ReactComponent as Home } from "../assets/icons/house.svg";
import { ReactComponent as MapR } from "../assets/icons/mapR.svg";
import { ReactComponent as User } from "../assets/icons/user.svg";
import { ReactComponent as Users } from "../assets/icons/users.svg";
import { ReactComponent as News } from "../assets/icons/newspaper.svg";
import { ReactComponent as File } from "../assets/icons/file-text.svg";
import { ReactComponent as FileD } from "../assets/icons/file-diff.svg";
import { ReactComponent as TPoint } from "../assets/icons/t-pointer.svg";
import { ReactComponent as Cloud } from "../assets/icons/cloudy.svg";
import { ReactComponent as Plus } from "../assets/icons/badge-plus.svg";
import { ReactComponent as Images } from "../assets/icons/images.svg";
import { ReactComponent as Woz } from "../assets/icons/circuit-board.svg";
import { ReactComponent as FAQ } from "../assets/icons/badge-alert.svg";
import { ReactComponent as Shield } from "../assets/icons/shield-user.svg";
import { ReactComponent as Login } from "../assets/icons/log-in.svg";
import { ReactComponent as WeightIcon } from "../assets/icons/weight-tilde.svg";

import DEF from "../assets/icons/def.svg";

export const  iconSvg = { WeightIcon, Login, Shield, FAQ, Woz, Images, Plus, Cloud, DEF, Logo, LogoText, LogoText2, Figure, Satellite, Street, Marks, Area, Datas, Secur, Home, MapR, User, Users, News, File, FileD, TPoint}

